import { PositionWizard } from '@/modules/position/components/PositionWizard';
import { useTranslation } from 'react-i18next';
import { DocumentTitle } from '@/shared/components/DocumentTitle.tsx';
import { FullscreenLoadingSuspenseBoundary } from '@/shared/components/FullscreenLoadingSuspenseBoundary.tsx';
import { BeforeUnloadContextProvider } from '@/shared/context/BeforeUnloadContext.tsx';
import { PageHeader } from '@/shared/components/PageHeader';
import { BalanceSheetContextProvider } from '@/shared/components/ProductGroupHeader/context/BalanceSheetContext';
import { usePositionContext } from '@/shared/context/PositionContext.tsx';

export function PositionPage() {
    const { t } = useTranslation();
    const { isEditing } = usePositionContext();

    return (
        <>
            <DocumentTitle title={t(isEditing ? 'positions.edit-position' : 'positions.create-position')} />
            <FullscreenLoadingSuspenseBoundary>
                <BalanceSheetContextProvider>
                    <BeforeUnloadContextProvider defaultEnabled>
                        <div className="bg-light-gray-200 flex min-h-screen flex-col items-center p-6">
                            <PageHeader
                                title={isEditing ? t('positions.edit-position') : t('positions.create-position')}
                                onCloseClickPath="/order-management/projects"
                            />
                            <PositionWizard />
                        </div>
                    </BeforeUnloadContextProvider>
                </BalanceSheetContextProvider>
            </FullscreenLoadingSuspenseBoundary>
        </>
    );
}
